export default [
    {
        path: 'impressao',
        component: () => import(
            /* webpackChunkName: 'pronto-atendimento-impressao' */
            '@/views/pronto-atendimento/impressao/Index'
        ),
        redirect: 'impressao/index',
        children: [
            {
                name: 'pronto-atendimento-impressao-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'pronto-atendimento-impressao' */
                    '@/views/pronto-atendimento/impressao/List'
                ),
            },
        ]
    }
]